import request from "@/api/request";

// 图形验证码
export function randomImage(key) {
  return request({
    url: "/api/sys/randomImage/" + key,
    method: "get"
  });
}

// 获取手机验证码
export function getPhoneCode(data) {
  return request({
    url: "/api/sys/sms",
    method: "post",
    data: {
      mobile: data
    }
  });
}

// 验证码登录
export function webPhoneLogin(data) {
  return request({
    url: "/api/sys/webPhoneLogin",
    method: "post",
    data: data
  });
}

// 手机密码登录
export function webPasswordLogin(data) {
  return request({
    url: "/api/sys/commonLogin",
    method: "post",
    data: data
  });
}

// 登录前的重置密码
export function resetPasswordFunc(data) {
  return request({
    url: "/api/sys/updPassword",
    method: "post",
    data: data
  });
}

// 验证码登录，没设密码的，调用接口设置一个密码
export function settingPassword(data) {
  return request({
    url: "/api/sys/updUserPassword",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": window.localStorage.getItem("token")
        ? window.localStorage.getItem("token")
        : ""
    }
  });
}

// 学员登录记录表
export function wdLoginRecord() {
  return request({
    url: "/api/student/wdLoginRecord/save",
    method: "post",
    data: { type: 1 },
    headers: {
      "Content-Type": "application/json",
      "X-Access-Token": window.localStorage.getItem("token")
        ? window.localStorage.getItem("token")
        : ""
    }
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js